import { CsvExportFile } from '@/pages/externals/pos-menu-masters/service';

/** Excel が UTF-8 と判定するための BOM */
const UTF8_BOM = String.fromCharCode(0xfeff);

/**
 * 生成したCSVをブラウザにダウンロードさせます。
 * Excel でダブルクリックして開いても文字化けしないよう、BOM 付きの UTF-8 で出します。
 * 取り込み（バックエンドの V-001）は BOM の有無を問わず UTF-8 として受け付けるため、そのまま再取込できます。
 */
export const downloadCsvFiles = (files: CsvExportFile[]): void => {
  files.forEach((file) => {
    const blob = new Blob([UTF8_BOM, file.content], {
      type: 'text/csv;charset=utf-8',
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = file.name;
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};
